import { Stack, TextField} from '@fluentui/react';
import React, { useEffect, useState } from 'react';

export interface IStatusProps {
    dev: boolean;
    apiUrl: string;
    username: string;
    token: string;
    site: string;
}

const StatusComponent : React.FunctionComponent<IStatusProps> = (props : IStatusProps) => {
    const [interval, setinterval] = useState<number>(30);
    const [logs, setlogs] = useState<string[]>([]);
    const [timerRunning, setTimerRunning] = useState<boolean>(false);
    const [fetching, setfetching] = useState<boolean>(false);

    useEffect(() => {
        if (!timerRunning) {
            setTimerRunning(true);
            GetStatus();
        }
    },[]);
    
    function GetStatus() {
        setfetching(true);
        fetch(`${props.apiUrl}/getServicesOutput?username=${props.username}&token=${props.token}&site=${props.site}`, {
            method: 'GET',
            mode: 'cors',
        }).then((response) => response.json()).then((data) => { 
            console.log({data});
            let tmp = data.logs.split('\n');
            setlogs(tmp.reverse());
            setfetching(false);
            setTimeout(() => {
                GetStatus();
            }, interval * 1000);
            
        }).catch( err => {
            console.log(err);
        });
    }
    
    return (  
        <Stack>
            <TextField disabled={fetching} label="Interval" value={interval.toString()} type='number' onChange={(e,v) => { setinterval(Number(v)); }} />
            {logs.map(log => {
                return <span>{log}</span>
            })}
        </Stack>
    );
}

export default StatusComponent;